import { createSvgIcon } from "./Icon";

// SVGファイルをraw文字列としてインポート
import homeSvgRaw from "./home.svg?raw";
import shiftScheduleSvgRaw from "./shift-schedule.svg?raw";
import workScheduleSvgRaw from "./work-schedule.svg?raw";
import tenantSvgRaw from "./tenant.svg?raw";
import workRulesSvgRaw from "./work-rules.svg?raw";
import organizationSvgRaw from "./organization.svg?raw";
import employeesSvgRaw from "./employees.svg?raw";
import shiftPatternsSvgRaw from "./shift-patterns.svg?raw";
import requiredManHoursSvgRaw from "./required-man-hours.svg?raw";
import tasksSvgRaw from "./tasks.svg?raw";
import displaySettingsSvgRaw from "./display-settings.svg?raw";
import analyticsSvgRaw from "./analytics.svg?raw";
import notificationsSvgRaw from "./notifications.svg?raw";
import storeSwitchSvgRaw from "./store-switch.svg?raw";
import accountSvgRaw from "./account.svg?raw";
import operationLogSvgRaw from "./operation-log.svg?raw";

/** 01 ホーム */
export const MenuHomeIcon = createSvgIcon(homeSvgRaw);
/** 02 シフト表 */
export const MenuShiftScheduleIcon = createSvgIcon(shiftScheduleSvgRaw);
/** 03 ワークスケジュール */
export const MenuWorkScheduleIcon = createSvgIcon(workScheduleSvgRaw);
/** 04 テナント設定 */
export const MenuTenantSettingsIcon = createSvgIcon(tenantSvgRaw);
/** 05 働き方設定 */
export const MenuWorkRulesIcon = createSvgIcon(workRulesSvgRaw);
/** 06 組織 */
export const MenuOrganizationIcon = createSvgIcon(organizationSvgRaw);
/** 07 従業員設定 */
export const MenuEmployeesIcon = createSvgIcon(employeesSvgRaw);
/** 08 シフトパターン設定 */
export const MenuShiftPatternsIcon = createSvgIcon(shiftPatternsSvgRaw);
/** 08b 必要人時 */
export const MenuRequiredManHoursIcon = createSvgIcon(requiredManHoursSvgRaw);
/** 09 タスク設定 */
export const MenuTasksIcon = createSvgIcon(tasksSvgRaw);
/** 10 表示設定 */
export const MenuDisplaySettingsIcon = createSvgIcon(displaySettingsSvgRaw);
/** 11 分析 */
export const MenuAnalyticsIcon = createSvgIcon(analyticsSvgRaw);
/** 12 お知らせ */
export const MenuNotificationsIcon = createSvgIcon(notificationsSvgRaw);
/** 13 店舗切替 */
export const MenuStoreSwitchIcon = createSvgIcon(storeSwitchSvgRaw);
/** 14 ログインアカウント */
export const MenuAccountIcon = createSvgIcon(accountSvgRaw);
/** 15 操作ログ */
export const MenuOperationLogIcon = createSvgIcon(operationLogSvgRaw);
